import React from "react";
import { Grid, Text, Title } from "@mantine/core";
import { PDFPage } from "./PDFPage";
import { CourseCard } from "../../../entities/components/CourseCard";
import useCoursesStore from "../../../store/useCoursesStore";
import { useTranslation } from "react-i18next";
import Image1 from "../../../shared/images/Course-1.png";
import Image2 from "../../../shared/images/Course-2.png";
import Image3 from "../../../shared/images/Course-3.png";
import Image4 from "../../../shared/images/Course-4.png";

const images = [Image1, Image2, Image3, Image4];

export const EssentialSkillCoursesPDF = () => {
  const { recommendedCourses } = useCoursesStore();
  const { t } = useTranslation();

  return (
    <PDFPage padding>
      <Title size={48} mb={16}>
        {t("relevant_courses_title")}
      </Title>
      <Text mb={48} size="28px" lh="42px" c="dimmed">
        {t("relevant_courses_description")}
      </Text>
      <Grid gutter={32}>
        {recommendedCourses.results.slice(0, 4).map((course, index) => (
          <Grid.Col span={6} key={index}>
            <CourseCard
              id={course.id}
              // image={course.image}
              image={images[index]}
              platform={course.platform}
              title={course.title}
              authors={course.authors}
              description={course.description}
              rating={course.rating ?? "Unrated"}
              url={course.url}
              isLearning={course.is_in_learnings}
              category={course.category}
              topics={course.topics}
              languages={course.languages}
              organization={course.organization}
              price={course.price}
              currency={course.currency}
              is_free={course.is_free}
              pdf
            />
          </Grid.Col>
        ))}
      </Grid>
    </PDFPage>
  );
};
